"use client";

import { ErrorBoundary } from "react-error-boundary";
import { Button, ExclamationTriangleIcon, Flex, Text } from "@paguelofacil/pf-components";
import { FormattedMessage } from "react-intl";

function ErrorFallback({ error, resetErrorBoundary }) {
    return (
        <Flex align="center" justify="center">
            <Flex align="center" direction="column" justify="center" width="60%" minW="auto" gap="1.5rem">
                <Flex align="center" direction="column" justify="center">
                    <ExclamationTriangleIcon color="#EDB600" size="32" isFullfill />
                    <Text variant="body2">
                        <FormattedMessage id="ups_error_title" defaultMessage="¡UPS algo no salió como esperábamos!" />
                    </Text>
                </Flex>
                <Flex align="center" direction="column" justify="center">
                    <Text variant="body4">
                        <FormattedMessage
                            id="ups_error_description"
                            defaultMessage="Estamos teniendo algunos problemas técnicos, si el problema persiste, por favor contáctanos."
                        />
                    </Text>
                </Flex>

                <Flex direction="column" align="flex-start" justify="flex-start">
                    <details style={{ whiteSpace: "pre-wrap" }}>{error?.message}</details>

                    <div>
                        <Button
                            type="button"
                            style={{ backgroundColor: "#378fa2", color: "#fff" }}
                            handleClick={resetErrorBoundary}
                        >
                            Reintentar
                        </Button>
                    </div>
                </Flex>
            </Flex>
        </Flex>
    );
}

export default function AppWithErrorBoundary({ children }) {
    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onError={(error, info) => {
                console.log("Error capturado:", error, info);
            }}
        >
            {children}
        </ErrorBoundary>
    );
}
